import type { CSSProperties, ReactNode } from 'react';
import { SUBPAGE_SURFACE } from '@/constants/surfaceColors';

type SubPageSurfaceProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

/** コンクリート背景上のコンテンツ面（フッター同色） */
export default function SubPageSurface({ children, className = '', style }: SubPageSurfaceProps) {
  return (
    <div className={`w-full ${className}`.trim()} style={{ background: SUBPAGE_SURFACE, ...style }}>
      {children}
    </div>
  );
}
